import React from 'react';
import { PitchDeck } from '../../types/pitchDeck';

interface DeckGalleryProps {
  decks: PitchDeck[];
  onSelectDeck: (deckId: string) => void;
}

export const DeckGallery: React.FC<DeckGalleryProps> = ({ decks, onSelectDeck }) => {
  // Format date helper
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  };
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {decks.map(deck => (
        <div 
          key={deck.id} 
          className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition duration-200"
          onClick={() => onSelectDeck(deck.id)}
        >
          <div 
            className="h-40 bg-cover bg-center"
            style={{ 
              backgroundColor: deck.coverImageUrl ? undefined : deck.theme.primaryColor,
              backgroundImage: deck.coverImageUrl ? `url(${deck.coverImageUrl})` : undefined
            }}
          >
            {!deck.coverImageUrl && (
              <div className="flex items-center justify-center h-full">
                <h3 className="text-white text-xl font-semibold px-4 text-center">{deck.title}</h3>
              </div>
            )}
          </div>
          
          <div className="p-4">
            {deck.coverImageUrl && <h3 className="text-lg font-semibold mb-2">{deck.title}</h3>}
            
            <div className="flex justify-between text-sm text-gray-600">
              <span>{deck.slides.length} slides</span>
              <span>{formatDate(deck.updatedAt)}</span>
            </div>
            
            <div className="flex mt-4 justify-between items-center">
              <span className={`px-2 py-1 text-xs rounded-full ${
                deck.status === 'completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
              }`}>
                {deck.status === 'completed' ? 'Completed' : 'Draft'}
              </span>
              
              <button 
                className="text-blue-600 hover:text-blue-800 font-medium"
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectDeck(deck.id);
                }}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
